import React from 'react'
import { SharedDataListableTable } from './SharedDataListableTable'

interface IManagerSharedDataTableProps {}
export const ManagerSharedDataTable: React.FC<IManagerSharedDataTableProps> = props => {
  return <SharedDataListableTable isDoctor={false}/>
}
